import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {CommonModule} from "@angular/common";
import {ProductService} from "@cybfed/core/services/marketplace/product.service";
import {TranslateModule} from "@ngx-translate/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {StickerAnimations} from "@white-label/pages/admin-mode/widgets/sticker-ad/sticker-ad-dashboard.component";
import {CurrencyPipe} from "@cybfed/shared/pipes/currency.pipe";

@Component({
    selector: 'app-donation-widget-stickers',
    templateUrl: './donation-widget-stickers.component.html',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        CurrencyPipe
    ],
    providers: [ProductService]
})
export class DonationWidgetStickersComponent implements OnInit {
    @Output() nextStepE: EventEmitter<any> = new EventEmitter();

    @Input() form!: FormGroup; // Reactive form group
    @Input() stickers!: any[]; // Reactive form group
    @Input() selectedStickers: any[] = [];
    @Input() course: number = 1;

    selectedAnimation = ''
    totalPrice: number = 0;
    private readonly stickerAnimations = StickerAnimations

    public animationTypes: any[] = []
    public stickersCount = 0;
    constructor(public mainStore: MainStoreService,
                ) {
        for (let animation of this.stickerAnimations) {
            this.animationTypes.push({
                name:'',
                animation: animation.key,
                stickerMinCount: animation.value,
            })
        }
    }

    ngOnInit() {
        this.totalPrice = 0;
    }

    donate() {
        this.nextStepE.emit({selectedStickers: this.selectedStickers, totalPrice: this.totalPrice, selectedAnimation: this.selectedAnimation});
    }

    select(sticker: any) {
        let index = this.selectedStickers.findIndex(s => s.serviceId === sticker._id)
        if (index === -1) {
            this.selectedStickers.push({
                serviceId: sticker._id,
                serviceCount: 1,
                img: sticker.media.mediaUrl,
                price: sticker.price ,
            })
        }else {
            this.selectedStickers[index].serviceCount ++;
        }
        this.totalPrice += sticker.price * this.course;
        this.stickersCount ++;

    }

    protected readonly FormControl = FormControl;

    removeSticker(sticker: any) {
        let index = this.selectedStickers.findIndex(s => s.serviceId === sticker.serviceId)
        if (index === -1) {
            return
        }
        this.totalPrice -= sticker.price * this.course;
        if (this.selectedStickers[index].serviceCount > 1) {
            this.selectedStickers[index].serviceCount -= 1;
        }else{
            this.selectedStickers.splice(index, 1);
        }
        this.stickersCount--
        if (this.selectedAnimation) {
            if (this.animationTypes[this.animationTypes.findIndex(at => at.animation === this.selectedAnimation)].stickerMinCount > this.stickersCount) {
                this.selectedAnimation = ''
            }
        }
    }

    selectAnimation(item:any) {
        if (!this.stickersCount) {
            return
        }
        if (this.stickersCount < item.stickerMinCount) {
            let addCount =   item.stickerMinCount - this.stickersCount;
            for (let i = 0; i < addCount; i++) {
                this.addSelectedStickers(i%this.selectedStickers.length);
            }
        }
        this.selectedAnimation = item.animation;

    }

    private addSelectedStickers(index: number) {
        this.selectedStickers[index].serviceCount ++;
        this.totalPrice += this.selectedStickers[index].price * this.course;
        this.stickersCount ++;

    }

    protected readonly Math = Math;
}
